import { SelectOption } from '@tryhackme/thm-ui-components';

export const statsPaginationOptions: SelectOption[] = [
  {
    id: '1',
    label: '10',
    value: '10',
  },
  {
    id: '2',
    label: '25',
    value: '25',
  },
  {
    id: '3',
    label: '50',
    value: '50',
  },
  {
    id: '4',
    label: '100',
    value: '100',
  },
];
